import { defineAsyncComponent } from 'vue';

const CAReceiptDetail = defineAsyncComponent(() => import('@/views/cash/CAReceipt/CAReceiptDetail.vue'));

const CAReceiptWithdrawDetail = defineAsyncComponent(() =>
  import('@/views/cash/CAReceipt/CAReceiptWithdrawDetail.vue')
);

const CAReceiptPlanWithdrawDetail = defineAsyncComponent(() =>
  import('@/views/cash/CAReceipt/CAReceiptPlanWithdrawDetail.vue')
);

const CAReceiptSaleDetail = defineAsyncComponent(() => import('@/views/sell/cAReceiptSale/CAReceiptSaleDetail.vue'));

const CAPaymentDetail = defineAsyncComponent(() => import('@/views/cash/CAPayment/CAPaymentDetail.vue'));

const CAPaymentDepositDetail = defineAsyncComponent(() => import('@/views/cash/CAPayment/CAPaymentDepositDetail.vue'));

const CAReceiptCustomerDetail = defineAsyncComponent(() =>
  import('@/views/sell/cAReceiptCustomer/CAReceiptCustomerDetail.vue')
);

const ApproveVoucherBUOpeningCommitmentTab = defineAsyncComponent(() =>
  import('@/views/treasury/bUCommitment/bUOpeningCommitment/ApproveVoucherBUOpeningCommitmentTab.vue')
);

const ApproveVoucherBADepositTab = defineAsyncComponent(() =>
  import('@/views/deposits/bADeposit/ApproveVoucherBADepositTab.vue')
);

const ApproveVoucherCAReceiptPlanWithdrawList = defineAsyncComponent(() =>
  import('@/views/cash/CAReceipt/ApproveVoucherCAReceiptPlanWithdrawList.vue')
);
const EmisDetail = defineAsyncComponent(() => import('@/views/connectEmis/EmisDetail.vue'));

const ApproveVoucherCAReceiptList = defineAsyncComponent(() =>
  import('@/views/cash/CAReceipt/ApproveVoucherCAReceiptList.vue')
);

const ApproveVoucherCAPayment = defineAsyncComponent(() =>
  import('@/views/cash/CAPayment/ApproveVoucherCAPayment.vue')
);

const ApproveVoucherSAInvoiceTab = defineAsyncComponent(() =>
  import('@/views/sell/sAInvoice/ApproveVoucherSAInvoiceTab.vue')
);
const ApproveVoucherCAReceiptCustomer = defineAsyncComponent(() =>
  import('@/views/sell/cAReceiptCustomer/ApproveVoucherCaReceiptCustomer.vue')
);

const CAFundInventoryAddPopup = defineAsyncComponent(() =>
  import('@/views/cash/CAInventory/CAFundInventoryAddPopup.vue')
);
const CAFundInventoryDetail = defineAsyncComponent(() =>
  import('@/views/cash/CAInventory/CAFundInventoryDetail.vue')
);
const CAFundInventoryChooseVoucher = defineAsyncComponent(() =>
  import('@/views/cash/CAInventory/CAFundInventoryChooseVoucher.vue')
);

export function registerCash(app) {
  app.component('CAReceiptDetail', CAReceiptDetail);

  app.component('CAReceiptWithdrawDetail', CAReceiptWithdrawDetail);

  app.component('CAReceiptPlanWithdrawDetail', CAReceiptPlanWithdrawDetail);

  app.component('CAReceiptSaleDetail', CAReceiptSaleDetail);

  app.component('CAPaymentDetail', CAPaymentDetail);

  app.component('CAPaymentDepositDetail', CAPaymentDepositDetail);

  app.component('CAReceiptCustomerDetail', CAReceiptCustomerDetail);

  app.component('ApproveVoucherBUOpeningCommitmentTab', ApproveVoucherBUOpeningCommitmentTab);

  app.component('ApproveVoucherBADepositTab', ApproveVoucherBADepositTab);

  app.component('ApproveVoucherCAReceiptPlanWithdrawList', ApproveVoucherCAReceiptPlanWithdrawList);

  app.component('ApproveVoucherCAReceiptList', ApproveVoucherCAReceiptList);

  app.component('ApproveVoucherCAPayment', ApproveVoucherCAPayment);

  app.component('ApproveVoucherSAInvoiceTab', ApproveVoucherSAInvoiceTab);

  app.component('ApproveVoucherCAReceiptCustomer', ApproveVoucherCAReceiptCustomer);
  app.component('EmisDetail', EmisDetail);
  app.component('CAFundInventoryAddPopup', CAFundInventoryAddPopup);
  app.component('CAFundInventoryDetail', CAFundInventoryDetail);
  app.component('CAFundInventoryChooseVoucher', CAFundInventoryChooseVoucher);
}
